const filterToggle = document.querySelector('.tc .session-filters__mobile-toggle');
const filterDrawer = document.querySelector('#session-filters');
const filterItem = document.querySelectorAll('.tc .filter-accordion__legend');

function openFilters() {
  filterDrawer.classList.add('is-active');
  filterDrawer.setAttribute('aria-expanded', 'true');
}

function closeFilters() {
  filterDrawer.classList.remove('is-active');
  filterDrawer.setAttribute('aria-expanded', 'false');
}

if (filterToggle) {
  // Show/hide filter toggle button
  window.addEventListener('load', (a) => {
    if (window.screen.width < 600) {
      filterDrawer.setAttribute('aria-expanded', 'false');
    } else {
      filterDrawer.setAttribute('aria-expanded', 'true');
    }
  });

  filterToggle.addEventListener('click', (t) => {
    if (filterDrawer.classList.contains('is-active')) {
      closeFilters();
    } else {
      openFilters();
    }
  });

  document.addEventListener('keyup', (e) => {
    const key = e.key || e.keyCode;
    if (key === 'Escape' || key === 'Esc' || key === 27) {
      closeFilters();
    }
  });

  // Filter accordions
  window.addEventListener('load', () => {
    Array.prototype.forEach.call(filterItem, (a) => {
      const button = a.querySelector('.filter-accordion__button');
      const drawer = a.nextElementSibling;
      button.onclick = () => {
        const expanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', !expanded);
        drawer.classList.toggle('expanded');

        if (drawer.style.maxHeight) {
          drawer.style.maxHeight = null;
        } else {
          drawer.style.maxHeight = `${drawer.scrollHeight}px`;
        }
      };
    });
  });
}
